import React, { useCallback, useState } from 'react';
import { ADVANCED_CONFIG_FIELDS, CONFIG_SPECIFIC_NODE_FIELDS } from '../../common/fields';
import * as actions from '../../containers/Advanced/advancedActions';
import JsonField from '../Controls/JsonField/JsonField';
import Label from '../Controls/Label/Label';
import Select from '../Controls/Select/Select';
import AdminConsoleConfig from './AdminConsoleConfig';

const { CONFIG_ADMIN_CONSOLE, CONFIG_ALL_NODES, CONFIG_NODE } = ADVANCED_CONFIG_FIELDS;
const { CONFIG } = CONFIG_SPECIFIC_NODE_FIELDS;

const AdvancedConfig = ({ fields, allFields, dispatch }) => {
    const adminConsoleConfig = fields[CONFIG_ADMIN_CONSOLE.ID];
    const allNodesConfig = fields[CONFIG_ALL_NODES.ID];
    const nodesConfigField = fields[CONFIG_NODE.ID];
    const nodesConfig = fields[CONFIG_NODE.ID]?.value || [];
    const [selectedNode, setSelectedNode] = useState(0);

    const selectOptions = nodesConfig.map((nodeId, index) => {
        return { value: index, label: nodeId[CONFIG.ID].name };
    });

    const dispatchUpdate = useCallback(
        (fieldId, value) => {
            dispatch({
                type: actions.UPDATE_ADVANCED_CONFIG,
                payload: { fieldId, value }
            });
        },
        [dispatch]
    );

    const dispatchUpdateNodesConfig = useCallback(
        (fieldId, value) => {
            dispatch({
                type: actions.UPDATE_NODES_SPECIFIC_CONFIG,
                payload: { fieldId, value, fieldIndex: selectedNode }
            });
        },
        [dispatch, selectedNode]
    );

    const onSelectNode = useCallback((_, nodeId) => {
        setSelectedNode(nodeId);
    }, []);

    const selectedNodeConfig = nodesConfig[selectedNode]?.[CONFIG.ID] || {};

    return (
        <>
            <AdminConsoleConfig adminConsoleConfig={adminConsoleConfig} onConfigChanged={dispatchUpdate} />
            {allNodesConfig && <JsonField field={allNodesConfig} changed={dispatchUpdate} />}
            {nodesConfigField && (
                <>
                    <Label value="Configure Specific Node" />
                    <Select value={selectedNode} options={selectOptions} changed={onSelectNode} searchable={true} />
                    {selectedNodeConfig && (
                        <JsonField
                            style={{ marginTop: '0' }}
                            field={selectedNodeConfig}
                            showName={false}
                            changed={dispatchUpdateNodesConfig}
                        />
                    )}
                </>
            )}
        </>
    );
};

export default React.memo(AdvancedConfig);
